
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BtnRadio from "@common/src/components/scope/btn-radio/index.vue";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import dayjs from "dayjs";
import echarts from "echarts";
import { addCurrencyUnit, addCurrencySymbol, formDownload } from "@common/src/utils/tools";
import ChartDate from "@common/src/components/scope/chart-date/index.vue";
import t from "@common/src/i18n/t";

const finance = namespace("finance");
const base = namespace("base");
@Component({
  components: { BtnRadio, ChartDate }
})
@Table("loadListData")
export default class ReportOutputValue extends Vue {
  @finance.Action getIncomeExpenseReportV2;
  @finance.Action getIncomeExpenseSumV2;
  @finance.Action queryReceiptDictionary;
  @finance.Action queryPaymentDictionary;
  @base.Action getDictionaryList;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  chartFormData: any = {
    statisticMethod: "1",
    beginTime: "",
    endTime: "",
    timeType: ""
  };
  listFormData: any = {
    statisticMethod: "1",
    incomeExpenseType: "1",
    beginTime: "",
    endTime: "",
    receiptType: "-1",
    paymentType: "-1"
  };
  listDataType: any = "income";
  nowDate: any = dayjs();
  tableData: any = [];
  grossProfitListData: any = [];
  created() {
    this.init();
  }
  myChart: any = {};
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(this.$refs.outputPie);
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
    if (this.urlIncomeExpenseType) {
      setTimeout(() => {
        // 1800随便写的，只要拉到最下面就行
        document.querySelector(".page-report-gross").scrollTop = 650;
      }, 200);
    }
  }
  amountData: any = {};
  paymentTypeList = [];
  receiptTypeList = [];
  dayDefaultKey = "";
  get urlIncomeExpenseType() {
    return this.$route.query.incomeExpenseType;
  }
  init() {
    if (this.urlIncomeExpenseType) {
      this.dayDefaultKey = "today_to_today";
      this.listFormData.incomeExpenseType = this.urlIncomeExpenseType;
    }
    this.queryPaymentDictionary().then(data => {
      const list = (data.data?.list || []).map(item => {
        item.label = item.dataDesc;
        item.value = item.dataValue;
        return item;
      });
      this.paymentTypeList = [
        {
          label: t("base.all"),
          value: "-1"
        },
        ...list
      ];
    });
    this.queryReceiptDictionary().then(data => {
      const list = (data.data?.list || []).map(item => {
        item.label = item.dataDesc;
        item.value = item.dataValue;
        return item;
      });
      this.receiptTypeList = [
        {
          label: t("base.all"),
          value: "-1"
        },
        ...list
      ];
    });
  }
  incomeExpenseList: any = [];
  handleView(row, type) {
    let href = "";
    if (type === "1") {
      href = this.$router.resolve({
        path: `/finance/collection-order-view/${row.incomeExpenseNo}`
      }).href;
    } else {
      href = this.$router.resolve({
        path: `/finance/payment-order-view/${row.incomeExpenseNo}`
      }).href;
    }
    window.open(href, "_blank");
  }
  handleViewListDetail(type) {
    this.listFormData.incomeExpenseType = type;
    this.mergeSumText();
    this.loadListData();
  }
  draw(serverData?) {
    let listData =
      this.chartFormData.statisticMethod === "1" ? serverData.data?.monthTrend || [] : serverData.data?.yearTrend || [];
    let xData = [];
    let incomeData = [];
    let expenseData = [];
    listData.forEach(item => {
      if (this.chartFormData.statisticMethod === "1") {
        xData.push(dayjs(item.title).format("MM-DD"));
      } else {
        xData.push(dayjs(item.title).format("YYYY-MM"));
      }
      incomeData.push(Number(item.incomeAmount));
      expenseData.push(Number(item.expenseAmount));
    });
    let options = {
      xAxis: {
        type: "category",
        data: xData,
        axisLabel: {
          textStyle: {
            //文字样式
            color: "#8C8C8C",
            fontSize: "12"
          },
          rotate: this.chartFormData.statisticMethod === "1" ? 40 : 0 //倾斜度可以根据需求设置
        },
        axisLine: {
          lineStyle: {
            color: "#8C8C8C"
          }
        }
      },
      tooltip: {
        trigger: "axis",
        formatter: params => {
          return `${params[0].name}<br/>${t("finance.earning")}: ${
            this.$localMark.currencySymbol + splitThousands(params[0].value)
          }<br/>${t("finance.expend")}: ${this.$localMark.currencySymbol + splitThousands(params[1].value)}`;
        }
        // formatter: `{b}<br/>收入: ${this.$localMark.currencySymbol}{c0}<br/>支出: ${this.$localMark.currencySymbol}{c1}`
      },
      legend: {
        data: [t("finance.earning"), t("finance.expend")],
        right: 10
      },
      grid: {
        x: 105,
        y: 40,
        x2: 105,
        y2: 40,
        borderWidth: 1
      },
      yAxis: {
        name: t("base.unit") + "：" + this.$localMark.currency,
        type: "value",
        axisLabel: {
          textStyle: {
            //文字样式
            color: "#8C8C8C",
            fontSize: "12"
          }
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      color: ["#2278F5", "#00B478"],
      series: [
        {
          name: t("finance.earning"),
          data: incomeData,
          type: "line"
        },
        {
          name: t("finance.expend"),
          data: expenseData,
          type: "line"
        }
      ]
    };
    // 绘制图表
    this.myChart.setOption(options);
  }
  grossProfitData: any = {};
  typeAmount = "0";
  @Table.LoadDataMethod()
  loadListData() {
    let params = Object.assign({}, this.listFormData, {
      receiptType: this.listFormData.receiptType === "-1" ? "" : this.listFormData.receiptType,
      paymentType: this.listFormData.paymentType === "-1" ? "" : this.listFormData.paymentType,
      orderItems: this.mix_sortParams,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    });
    return this.getIncomeExpenseSumV2(params).then(data => {
      this.amountData = data.data;
      this.incomeExpenseList = data.data.list;
      this.typeAmount = data.data.typeFeeSum;
      return data;
    });
  }
  handleTableDateTypeChange(val) {
    if (val === "1") {
      this.listFormData.statisticDate = this.nowDate.subtract(1, "d").format("YYYYMMDD");
    } else {
      this.listFormData.statisticDate = this.nowDate.subtract(1, "M").format("YYYYMM");
    }
    this.loadListData();
  }
  handleListDateChange() {
    this.loadListData();
  }
  loadChartData() {
    this.getIncomeExpenseReportV2(this.chartFormData).then(data => {
      this.draw(data);
    });
  }
  trendDateChange(data) {
    console.log(1, data);
    this.chartFormData.statisticMethod = data.type;
    this.chartFormData.beginTime = data.value[0];
    this.chartFormData.endTime = data.value[1];
    this.chartFormData.timeType = data.dateType;
    this.loadChartData();
  }
  tableDateChange(data) {
    this.listFormData.statisticMethod = data.type;
    this.listFormData.beginTime = data.value[0];
    this.listFormData.endTime = data.value[1];
    this.listFormData.timeType = data.dateType;
    this.loadListData();
  }
  handleTransactionTypeChange() {
    this.loadListData();
    this.mergeSumText();
  }
  sumText = t("v216_6.all-income");
  mergeSumText() {
    if (this.listFormData.incomeExpenseType === "1") {
      const typeDesc = this.receiptTypeList.find(item => item.value === this.listFormData.receiptType).label;
      this.sumText = `${typeDesc}${t("finance.income")}`;
    } else {
      const typeDesc = this.paymentTypeList.find(item => item.value === this.listFormData.paymentType).label;
      this.sumText = `${typeDesc}${t("finance.expense")}`;
    }
  }
  handleExport() {
    let params = Object.assign({}, this.listFormData, {
      receiptType: this.listFormData.receiptType === "-1" ? "" : this.listFormData.receiptType,
      paymentType: this.listFormData.paymentType === "-1" ? "" : this.listFormData.paymentType
    });
    formDownload(`${window.API_URL}/report/v2/queryIncomeExpenseResult/download`, params);
  }
}
